import theme from './theme/zh_CN';
import profile from './profile/zh_CN';
import member from './member/zh_CN';
import organization from './organization/zh_CN';
import console from './console/zh_CN';
import aws from './aws/zh_CN';
import activity from './activity/zh_CN';

export default {
  ...theme,
  ...profile,
  ...organization,
  ...console,
  ...member,
  ...aws,
  ...activity,
};
